"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payload = void 0;
const updateModel = {
    data: {
        type: 'booking',
        attributes: {
            booking_items_attributes: [],
        },
    },
};
class Payload {
    constructor(items) {
        this.model = updateModel;
        this.model.data.attributes.booking_items_attributes = items;
    }
}
exports.Payload = Payload;
//# sourceMappingURL=payloadHelper.js.map